import React from 'react'

import { SocialConfigContextProps } from 'interfaces'

export const SocialConfigContext = React.createContext(
  {} as SocialConfigContextProps
)
